<template>
	<div
		@mousedown="startArea"
		@mousemove="sizeArea"
		@mouseup="finishArea"
		class="area-container"
	>
		<div
			v-for="(area, index) in areas"
			:key="'area' + index"
			:id="'area' + index"
			class="area"
			@contextmenu.prevent="removeArea(area)"
			@mousedown="areaMove(index)"
			@dblclick="renameArea(area, index)"
			:style="{
				bottom: area.startY * areaHeightRatio + 'px',
				left: area.startX * areaWidthRatio + 'px',
				width: getAreaWidth(area) * areaWidthRatio + 'px',
				height: getAreaHeight(area) * areaHeightRatio + 'px',
				'pointer-events': dragging || moveItem || disable ? 'none' : 'all'
			}"
		>
			<div
				class="resizers"
				v-if="!areaDrag && !moveItem && !dragging && !disable"
			>
				<div
					class="resizer top-left"
					@mousedown="startResize(1, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer top"
					@mousedown="startResize(2, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer top-right"
					@mousedown="startResize(3, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer right"
					@mousedown="startResize(4, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer bottom-right"
					@mousedown="startResize(5, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer bottom"
					@mousedown="startResize(6, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer bottom-left"
					@mousedown="startResize(7, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
				<div
					class="resizer left"
					@mousedown="startResize(8, index, $event)"
					:style="!resizing ? 'pointer-events: all' : ''"
				/>
			</div>
			<input
				v-if="editingAreaName && areaIndex == index"
				@mouseup.stop
				@keyup.esc="cancelEditName"
				@keyup.enter="saveAreaName"
				type="text"
				:placeholder="$t('area_component.area_name_placeholder')"
				v-model="newAreaName"
			/>
			<p v-else>{{ area.name }}</p>
		</div>
	</div>
</template>

<script>
export default {
	model: {
		prop: 'makingArea',
		event: 'areaStatus'
	},

	props: {
		areas: Array,
		areaWidthRatio: Number,
		areaHeightRatio: Number,
		moveItem: Boolean,
		dragging: Boolean,
		makingArea: Boolean,
		disable: Boolean
	},

	data: () => ({
		areaDrag: false,
		startX: 0,
		startY: 0,
		resizing: false,
		orientation: 0,
		movingArea: false,
		areaIndex: 0,
		editingAreaName: false,
		newAreaName: ''
	}),

	methods: {
		getAreaHeight(area) {
			return area.endY - area.startY;
		},
		getAreaWidth(area) {
			return area.endX - area.startX;
		},
		startArea(ev) {
			if (ev.shiftKey && this.$isAllowedTo('floor_areas_edit')) {
				this.$emit('areaStatus', true);
				this.areaDrag = true;
				const dropZoneHeight = document.getElementById('dropZone').offsetHeight / this.areaHeightRatio;

				if (ev.target.id === 'dropZone') {
					this.areas.push({
						name: this.$t('area_component.default_name', { number: this.areas.length + 1 }),
						startX: ev.offsetX / this.areaWidthRatio,
						endX: ev.offsetX / this.areaWidthRatio,
						startY: dropZoneHeight - ev.offsetY / this.areaHeightRatio,
						endY: dropZoneHeight - ev.offsetY / this.areaHeightRatio
					});
					this.startX = ev.offsetX / this.areaWidthRatio;
					this.startY = dropZoneHeight - ev.offsetY / this.areaHeightRatio;
				} else {
					this.areas.push({
						name: this.$t('area_component.default_name', { number: this.areas.length + 1 }),
						startX:
              (ev.toElement.offsetLeft + ev.offsetX) / this.areaWidthRatio,
						endX: (ev.toElement.offsetLeft + ev.offsetX) / this.areaWidthRatio,
						startY:
              dropZoneHeight -
              (ev.toElement.offsetTop + ev.offsetY) / this.areaHeightRatio,
						endY:
              dropZoneHeight -
              (ev.toElement.offsetTop + ev.offsetY) / this.areaHeightRatio
					});
					this.startX =
            (ev.toElement.offsetLeft + ev.offsetX) / this.areaWidthRatio;
					this.startY =
            dropZoneHeight -
            (ev.toElement.offsetTop + ev.offsetY) / this.areaHeightRatio;
				}

				this.areaIndex = this.areas.length - 1;
			}
		},
		sizeArea(ev) {
			if (!ev.toElement) return;

			const dropZoneHeight =
						document.getElementById('dropZone').offsetHeight / this.areaHeightRatio;
			const offsetX = ev.offsetX / this.areaWidthRatio;
			const offsetY = dropZoneHeight - ev.offsetY / this.areaHeightRatio;
			const parentOffsetX =
						(ev.toElement.offsetLeft + ev.offsetX) / this.areaWidthRatio;
			const parentOffsetY =
				dropZoneHeight -
				(ev.toElement.offsetTop + ev.offsetY) / this.areaHeightRatio;

			if (this.areaDrag) {
				// Sizing area
				const area = this.areas[this.areas.length - 1];

				if (ev.target.id === 'dropZone') {
					// Handle X
					if (offsetX >= this.startX) {
						area.startX = this.startX;
						area.endX = offsetX;
					} else if (offsetX <= this.startX) {
						area.startX = offsetX;
					}

					// Handle Y
					if (offsetY >= this.startY) {
						area.startY = this.startY;
						area.endY = offsetY;
					} else if (offsetY <= this.startY) {
						area.startY = offsetY;
					}
				} else {
					// Handle X
					if (parentOffsetX >= this.startX) {
						area.startX = this.startX;
						area.endX = parentOffsetX;
					} else if (parentOffsetX <= this.startX) {
						area.startX = parentOffsetX;
					}

					// Handle Y
					if (parentOffsetY >= this.startY) {
						area.startY = this.startY;
						area.endY = parentOffsetY;
					} else if (parentOffsetY <= this.startY) {
						area.startY = parentOffsetY;
					}
				}
			} else if (this.resizing) {
				//Resizing area
				const area = this.areas[this.areaIndex];
				switch (this.orientation) {
				case 1: //Top right resize
					if (ev.target.id === 'dropZone') {
						if (offsetX < area.endX) {
							area.startX = offsetX;
						}

						area.endY = offsetY;
					} else {
						if (parentOffsetX < area.endX) {
							area.startX = parentOffsetX;
						}

						area.endY = parentOffsetY;
					}

					break;
				case 2: //Top resize
					if (ev.target.id === 'dropZone') {
						area.endY = offsetY;
					} else {
						area.endY = parentOffsetY;
					}

					break;
				case 3: //Top left resize
					if (ev.target.id === 'dropZone') {
						area.endY = offsetY;
						area.endX = offsetX;
					} else {
						area.endY = parentOffsetY;
						area.endX = parentOffsetX;
					}

					break;
				case 4: //Right resize
					if (ev.target.id === 'dropZone') {
						area.endX = offsetX;
					} else {
						area.endX = parentOffsetX;
					}

					break;
				case 5: //Bottom right resize
					if (ev.target.id === 'dropZone') {
						if (offsetY < area.endY) {
							area.startY = offsetY;
						}

						area.endX = offsetX;
					} else {
						if (parentOffsetY < area.endY) {
							area.startY = parentOffsetY;
						}

						area.endX = parentOffsetX;
					}

					break;
				case 6: //Bottom resize
					if (ev.target.id === 'dropZone') {
						if (offsetY < area.endY) {
							area.startY = offsetY;
						}
					} else {
						if (parentOffsetY < area.endY) {
							area.startY = parentOffsetY;
						}
					}

					break;
				case 7: //Bottom left resize
					if (ev.target.id === 'dropZone') {
						if (offsetY < area.endY) {
							area.startY = offsetY;
						}

						if (offsetX < area.endX) {
							area.startX = offsetX;
						}
					} else {
						if (parentOffsetY < area.endY) {
							area.startY = parentOffsetY;
						}

						if (parentOffsetX < area.endX) {
							area.startX = parentOffsetX;
						}
					}

					break;
				case 8: //Left resize
					if (ev.target.id === 'dropZone') {
						if (offsetX < area.endX) {
							area.startX = offsetX;
						}
					} else {
						if (parentOffsetX < area.endX) {
							area.startX = parentOffsetX;
						}
					}

					break;
				}
			} else if (this.movingArea) {
				const area = this.areas[this.areaIndex];
				area.startX += ev.movementX / this.areaWidthRatio;
				area.endX += ev.movementX / this.areaWidthRatio;
				area.startY -= ev.movementY / this.areaHeightRatio;
				area.endY -= ev.movementY / this.areaHeightRatio;
			}
		},
		finishArea() {
			if (!this.areaDrag && !this.movingArea && !this.resizing) return;

			if (this.areaIndex != -1) {
				let area = this.areas[this.areaIndex];
				this.areaIndex = -1;

				if (area.startX < 0) {
					area.endX -= area.startX;
					area.startX = 0;
				}

				if (area.startY < 0) {
					area.endY -= area.startY;
					area.startY = 0;
				}

				if (area.endX > 1000) {
					area.startX -= area.endX - 1000;
					area.endX = 1000;
				}

				if (area.endY > 1000) {
					area.startY -= area.endY - 1000;
					area.endY = 1000;
				}

				if (this.editingAreaName) {
					area.name = this.newAreaName;
					this.editingAreaName = false;
				}

				this.saveArea(area);
				this.areaIndex = -1;
			}

			this.areaDrag = false;
			this.resizing = false;
			this.movingArea = false;
			this.$emit('areaStatus', false);
		},
		saveArea(area) {
			area.startX = parseInt(area.startX);
			area.endX = parseInt(area.endX);
			area.startY = parseInt(area.startY);
			area.endY = parseInt(area.endY);
			this.$emit('saveArea', area);
		},
		removeArea(area) {
			if (this.$isAllowedTo('floor_areas_delete')) this.$emit('deleteArea', area);
		},
		startResize(orientation, index) {
			if (!event.ctrlKey && !event.shiftKey && this.$isAllowedTo('floor_areas_edit')) {
				this.resizing = true;
				this.orientation = orientation;
				this.areaIndex = index;
			}
		},
		areaMove(index) {
			if (event.ctrlKey && this.$isAllowedTo('floor_areas_edit')) {
				this.areaIndex = index;
				this.movingArea = true;
			}
		},
		renameArea(area, index) {
			if (this.$isAllowedTo('floor_areas_edit')) {
				this.areaIndex = index;
				this.editingAreaName = true;
				this.newAreaName = area.name;
			}
		},
		saveAreaName() {
			var area = this.areas[this.areaIndex];
			area.name = this.newAreaName;
			this.editingAreaName = false;
			this.newAreaName = '';
			this.$emit('saveArea', area);
		},
		cancelEditName() {
			this.editingAreaName = false;
			this.newAreaName = '';
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.area-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.area {
  background-color: $area-background;
  border: 1px solid $area-border;
  position: absolute;
  z-index: 1;
  color: $dark;
}
.area p {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  pointer-events: none;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.area input {
  text-align: center;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 2px;
  border: 1px solid $primary;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.area .resizers {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  pointer-events: none;
}
.area .resizers .resizer {
  width: 12px;
  height: 12px;
  position: absolute;
}
.area .resizers .resizer.top-left {
  left: -3px;
  top: -3px;
  cursor: nwse-resize; /*resizer cursor*/
}
.area .resizers .resizer.top-right {
  right: -3px;
  top: -3px;
  cursor: nesw-resize;
}
.area .resizers .resizer.bottom-left {
  left: -3px;
  bottom: -3px;
  cursor: nesw-resize;
}
.area .resizers .resizer.bottom-right {
  right: -3px;
  bottom: -3px;
  cursor: nwse-resize;
}
.area .resizers .resizer.top {
  left: 9px;
  width: calc(100% - 18px);
  top: -3px;
  cursor: ns-resize; /*resizer cursor*/
  height: 7px;
}
.area .resizers .resizer.bottom {
  left: 9px;
  width: calc(100% - 18px);
  bottom: -3px;
  cursor: ns-resize; /*resizer cursor*/
  height: 7px;
}
.area .resizers .resizer.left {
  left: -3px;
  height: calc(100% - 18px);
  bottom: 9px;
  cursor: ew-resize; /*resizer cursor*/
  width: 7px;
}
.area .resizers .resizer.right {
  right: -3px;
  height: calc(100% - 18px);
  bottom: 9px;
  cursor: ew-resize; /*resizer cursor*/
  width: 7px;
}
</style>
